// PM Feedback Batch 1, item 4 (2026-09) — display-layer-only fix (explicitly "No Notion
// edits"): many freelancer bios use " — " as an informal separator between distinct chunks
// (location, experience, availability, etc). Splitting them into separate lines here makes
// them readable without ever touching the underlying stored text.
export function splitDashSegments(text) {
  if (!text || typeof text !== "string") return [];
  return text
    .split(/\s+[—–]\s+/)
    .map((s) => s.trim())
    .filter(Boolean);
}
